const CONNECT_SERVO_LIVE = 'scratch-gui/servo-live/CONNECT_SERVO_LIVE';
const DISCONNECT_SERVO_LIVE = 'scratch-gui/servo-live/DISCONNECT_SERVO_LIVE';
const SET_SERVO_LIVE_CONNECTED = 'scratch-gui/servo-live/SET_SERVO_LIVE_CONNECTED';

const initialState = {
    enabled: false,
    portPath: null,
    connected: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;

    switch (action.type) {
    case CONNECT_SERVO_LIVE:
        console.log('CONNECT_SERVO_LIVE reducer', action.portPath);
        return {
            ...state,
            enabled: true,
            portPath: action.portPath,
            connected: true
        };
    case DISCONNECT_SERVO_LIVE:
        return {
            ...state,
            enabled: false,
            portPath: null,
            connected: false
        };
    case SET_SERVO_LIVE_CONNECTED:
        return {
            ...state,
            connected: action.connected
        };
    default:
        return state;
    }
};

const connectServoLive = portPath => ({
    type: CONNECT_SERVO_LIVE,
    portPath
});

const disconnectServoLive = () => ({
    type: DISCONNECT_SERVO_LIVE
});

const setServoLiveConnected = connected => ({
    type: SET_SERVO_LIVE_CONNECTED,
    connected
});

export {
    reducer as default,
    initialState as servoLiveInitialState,
    connectServoLive,
    disconnectServoLive,
    setServoLiveConnected
};
